var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('router-view',{staticStyle:{"height":"calc(100% - 70px)"}}),_c('nut-tabbar',{attrs:{"tabbarList":_vm.tabList,"bottom":true},on:{"tab-switch":_vm.tabSwitch3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }